<template>
  <div class="dv5-shared-carousel">
    <VueSlickCarousel v-if="view.length > 0" v-bind="settings" :key="forceUpdateOnResize">
      <slot
        name="slide"
        v-for="(slide, index) in view"
        :slide="slide"
        :slideClass="'custom-slide'"
      >
        <div class="custom-slide" :key="index">
          <div class="example-card">{{slide.title}} {{index+1}}</div>
        </div>
      </slot>

      <template #prevArrow="arrowOption">
        <div class="custom-arrow custom-arrow-prev">
          <i class="fa fa-arrow-left" ></i>
        </div>
      </template>

      <template #nextArrow="arrowOption">
        <div class="custom-arrow custom-arrow-next">
          <i class="fa fa-arrow-right" ></i>
        </div>
      </template>

      <template #customPaging="page">
        <div class="custom-dot"><span>{{page+1}}</span></div>
      </template>
    </VueSlickCarousel>
    <div v-else class="no-data">
      <h3>Nenhum dado encontrado!</h3>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'dv5-shared-carousel',
    props: {
      'view': {
        type: Array,
        default: () => [
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
          { title: "Example slide" },
        ]
      },
      dots: {
        type: Boolean,
        default: true
      },
      infinite: {
        type: Boolean,
        default: true
      },
      speed: {
        type: Number,
        default: 500
      },
      initialSlide: {
        type: Number,
        default: 0
      },
      arrows: {
        type: Boolean,
        default: true
      },
      slidesToShow: {
        type: Number,
        default: 3
      },
      slidesToScroll: {
        type: Number,
        default: 3
      }, // tamanho do salto
      rows: {
        type: Number,
        default: 1
      },
      swipe: {
         type: Boolean,
         default: true
      },
      swipeToSlide: {
        type: Boolean,
        default: true
      },
      responsive: {
        type: Array,
        default: function () {
          return [
            {
              "breakpoint": 100000,
              "settings": {
                "slidesToShow": 4,
                "slidesToScroll": 4,
                'rows': 1,
                'dots': true
              }
            },
            {
              "breakpoint": 1920,
              "settings": {
                "slidesToShow": 3,
                "slidesToScroll": 3,
                'rows': 1,
                'dots': true
              }
            },
            {
              'breakpoint': 1366,
              'settings': {
                  'slidesToShow': 2,
                  'slidesToScroll': 2,
                  'rows': 1,
                  'dots': true
              }
            },
            {
              "breakpoint": 850,
              "settings": {
                "slidesToShow": 1,
                "slidesToScroll": 1,
                'rows': 1,
                'dots': true
              }
            },
              {
                'breakpoint': 768,
                'settings': {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  'cols': 1,
                  'rows': 1,
                  'arrows': true,
                  'dots': true
                }
              },
              {
                'breakpoint': 500,
                'settings': {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  'cols': 1,
                  'rows': 1,
                  'arrows': true,
                  'dots': true
                }
              },
              {
                'breakpoint': 450,
                'settings': {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  'cols': 1,
                  'rows': 1,
                  'arrows': true,
                  'dots': true
                }
              },
              {
                'breakpoint': 200,
                'settings': {
                  "slidesToShow": 1,
                  'cols': 1,
                  'rows': 1,
                  'arrows': false,
                  'dots': true
                }
              },
          ]
        }
      },
    },
    data(){
      return {
        settings: {
          dots: this.dots,
          infinite: this.infinite,
          speed: this.speed,
          initialSlide: this.initialSlide,
          slidesToShow: this.slidesToShow,
          slidesToScroll: this.slidesToScroll, // tamanho do salto
          rows: this.rows,
          swipe: this.swipe,
          swipeToSlide: this.swipeToSlide,
          arrows: this.arrows,

          // autoplay: true,
          // autoplaySpeed: 1500,
          // pauseOnDotsHover: true,
          // pauseOnFocus: true,
          // pauseOnHover: true

          dotsClass: 'custom-dots slick-dots',
          "responsive": this.responsive,
        },
        forceUpdateOnResize: Math.round(Math.random() * 1000)
      }
    },
    methods: {
      onResize(){ // force update dots on window resize
        this.forceUpdateOnResize = Math.round(Math.random() * 1000)
      }
    },
    created(){
    },
    mounted(){
      this.onResize()
      window.addEventListener("resize", this.onResize);
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../scss/extras/_variables';
  .custom-slide{
    min-height: 150px;

    padding: 5px 5px;
    display: grid!important;
    align-content: stretch;
    justify-content: stretch;
    .example-card{
      background-color: $dv5-color4;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
    }
  }

  .dv5-shared-carousel{
    padding: 0 70px;
  }
  @media (max-width: 700px) {
      .dv5-shared-carousel {
          padding: 0 45px;
      }

      .custom-dot{
          background-color: #FFFFFFFF;
          width: 15px!important;
          height: 8px!important;
          border-radius: 10px!important;

          font-family: Lato;
          font-size: 10px;
          color: #434343FF;
          font-weight: bold;


          display: flex;
          align-items: center;
          justify-content: center;

          span {
              display: none!important;
          }
      }
      .slick-active{
          .custom-dot{
              background-color: #0080FCFF !important;
              color: #FFFFFF;

              span {
                  display: none!important;
              }
          }
      }
  }
  .custom-arrow{
    background-color: $dv5-color4;
    height: 46px;
    width: 46px;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 22px;
    color: $dv5-color5;

    &::before{
      display: none;
    }

    &:hover{
      cursor: pointer;
    }
  }

  .custom-arrow-prev{
    left: -58px!important;
  }
  .custom-arrow-next{
    right: -58px!important;
  }

  .slick-list{
    margin: 0 60px!important;
  }

  .custom-dot{
    background-color: $dv5-color4;
    width: 20px;
    height: 20px;
    border-radius: 50%;

    font-family: Lato;
    font-size: 10px;
    color: $dv5-color2;
    font-weight: bold;


    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slick-active{
    .custom-dot{
      background-color: $dv5-color1!important;
      color: $dv5-color4;
    }
  }

  .no-data{
    font-family: Mulish;
    font-size: 48px;
    font-weight: bold;
    color: $dv5-color2;

    padding: 0 60px;
    text-align: center;
  }

  @media screen and (max-width: 700px) {
    .custom-arrow{
      width: 28px;
      height: 28px;
    }
    .fa-arrow-left,
    .fa-arrow-right{
      font-size: .8rem;
    }
    .custom-arrow-prev{
      left: -45px !important;
    }
    .custom-arrow-next{
      right: -45px !important;
    }
  }

</style>

<style lang="scss">
  .slick-track { /* IGUALA ALTURA DOS CARDS */
    align-items: stretch!important;
    display: flex!important;
    .slick-slide{
      height: auto!important; // nao remover

      justify-content: stretch!important;
      align-items: stretch!important;
      display: flex!important;
      flex-direction: column!important;
      &>div{
        height: 100%!important;
        width: 100%!important;

        justify-content: stretch!important;
        align-items: stretch!important;
        display: flex!important;
      }
    }
  }

  *:focus { /* disable outline on click into slide */
    outline: 0;
    outline: none;
  }
  .dv5-shared-carousel .custom-dots{
    position: static;
    padding-top: 5px
  }
  @media (max-width: 701px) {
      .dv5-shared-carousel .custom-dots {
          padding: 3px;
      }
      .dv5-shared-carousel .custom-dots li
      {
          position: relative;

          display: inline-block;

          width: 15px!important;
          height: 8px!important;
          margin: 0 5px;
          padding: 0;

          cursor: pointer;
      }
  }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/shared/Carousel.vue